import { toSentenceCase } from '@noths/polaris-client-utils';

import { FilterUid } from 'src/components/organisms/Filter/constants/uids';
import type { Filter } from 'src/redux/productsQuery/types/Filter';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';

export const getFiltersWithSortFilter = (filters: Filter[], sortOptions: SortOption[]) => {
  const sortFilter: Filter = {
    active: false,
    options: sortOptions.map(({ active, id, title }) => ({
      uid: id,
      value: id,
      title: toSentenceCase(title),
      active,
      activeCount: null,
    })),
    title: 'Sort',
    type: 'radio',
    uid: FilterUid.Sort,
  };

  return [sortFilter, ...filters];
};
